let onUnauthorized: () => void = () => {}

export function setUnauthorizedHandler(fn: () => void) {
  onUnauthorized = fn
}

export async function authedFetch(input: RequestInfo | URL, init?: RequestInit) {
  const res = await fetch(input, { ...init, credentials: 'include' })
  if (res.status === 401) {
    onUnauthorized()
  }
  return res
}
